
const lindauMeetings = [
	'73rd Lindau Nobel Laureate Meeting (2024)',
	'72nd Lindau Nobel Laureate Meeting (2023)',
	'7th Lindau Meeting on Economic Sciences (2022)',
	'71st Lindau Nobel Laureate Meeting (2022)',
	'70th Lindau Nobel Laureate Meeting (2021)',
	'69th Lindau Nobel Laureate Meeting (2019)',
	'68th Lindau Nobel Laureate Meeting (2018)',
	'6th Lindau Meeting on Economic Sciences (2017)',
	'67th Lindau Nobel Laureate Meeting (2017)',
	'66th Lindau Nobel Laureate Meeting (2016)',
	'65th Lindau Nobel Laureate Meeting (2015)',
	'5th Lindau Meeting on Economic Sciences (2014)',
	'64th Lindau Nobel Laureate Meeting (2014)',
	'63rd Lindau Nobel Laureate Meeting (2013)',
	'62nd Lindau Nobel Laureate Meeting (2012)',
	'4th Lindau Meeting on Economic Sciences (2011)',
	'61st Lindau Nobel Laureate Meeting (2011)',
	'60th Lindau Nobel Laureate Meeting (2010)',
	'59th Lindau Nobel Laureate Meeting (2009)',
	'3rd Lindau Meeting on Economic Sciences (2008)',
	'58th Lindau Nobel Laureate Meeting (2008)',
	'57th Lindau Nobel Laureate Meeting (2007)',
	'56th Lindau Nobel Laureate Meeting (2006)',
	'2nd Lindau Meeting on Economic Sciences (2006)',
	'55th Lindau Nobel Laureate Meeting (2005)',
	'1st Lindau Meeting on Economic Sciences (2004)',
	'54th Lindau Nobel Laureate Meeting (2004)',
	'53rd Lindau Nobel Laureate Meeting (2003)',
	'52nd Lindau Nobel Laureate Meeting (2002)',
	'51st Lindau Nobel Laureate Meeting (2001)',
	'50th Lindau Nobel Laureate Meeting (2000)',
	'49th Lindau Nobel Laureate Meeting (1999)',
	'48th Lindau Nobel Laureate Meeting (1998)',
	'47th Lindau Nobel Laureate Meeting (1997)',
	'46th Lindau Nobel Laureate Meeting (1996)',
	'45th Lindau Nobel Laureate Meeting (1995)',
	'44th Lindau Nobel Laureate Meeting (1994)',
	'43rd Lindau Nobel Laureate Meeting (1993)',
	'42nd Lindau Nobel Laureate Meeting (1992)',
	'41st Lindau Nobel Laureate Meeting (1991)',
	'40th Lindau Nobel Laureate Meeting (1990)',
	'39th Lindau Nobel Laureate Meeting (1989)',
	'38th Lindau Nobel Laureate Meeting (1988)',
	'37th Lindau Nobel Laureate Meeting (1987)',
	'36th Lindau Nobel Laureate Meeting (1986)',
	'35th Lindau Nobel Laureate Meeting (1985)',
	'34th Lindau Nobel Laureate Meeting (1984)',
	'33rd Lindau Nobel Laureate Meeting (1983)',
	'32nd Lindau Nobel Laureate Meeting (1982)',
	'31st Lindau Nobel Laureate Meeting (1981)',
	'30th Lindau Nobel Laureate Meeting (1980)',
	'29th Lindau Nobel Laureate Meeting (1979)',
	'28th Lindau Nobel Laureate Meeting (1978)',
	'27th Lindau Nobel Laureate Meeting (1977)',
	'26th Lindau Nobel Laureate Meeting (1976)',
	'25th Lindau Nobel Laureate Meeting (1975)',
	'24th Lindau Nobel Laureate Meeting (1974)',
	'23rd Lindau Nobel Laureate Meeting (1973)',
	'22nd Lindau Nobel Laureate Meeting (1972)',
	'21st Lindau Nobel Laureate Meeting (1971)',
	'20th Lindau Nobel Laureate Meeting (1970)',
	'19th Lindau Nobel Laureate Meeting (1969)',
	'18th Lindau Nobel Laureate Meeting (1968)',
	'17th Lindau Nobel Laureate Meeting (1967)',
	'16th Lindau Nobel Laureate Meeting (1966)',
	'15th Lindau Nobel Laureate Meeting (1965)',
	'14th Lindau Nobel Laureate Meeting (1964)',
	'13th Lindau Nobel Laureate Meeting (1963)',
	'12th Lindau Nobel Laureate Meeting (1962)',
	'11th Lindau Nobel Laureate Meeting (1961)',
	'10th Lindau Nobel Laureate Meeting (1960)',
	'9th Lindau Nobel Laureate Meeting (1959)',
	'8th Lindau Nobel Laureate Meeting (1958)',
	'7th Lindau Nobel Laureate Meeting (1957)',
	'6th Lindau Nobel Laureate Meeting (1956)',
	'5th Lindau Nobel Laureate Meeting (1955)',
	'4th Lindau Nobel Laureate Meeting (1954)',
	'3rd Lindau Nobel Laureate Meeting (1953)',
	'2nd Lindau Nobel Laureate Meeting (1952)',
	'1st Lindau Nobel Laureate Meeting (1951)',
];

const mentoringScopes: string[] = [
	'CareerMentoring',
	'ProfessionalDevelopmentMentoring',
	'PersonalDevelopmentMentoring',
	'CareerAdvice',
	'StudyAdvice',
	'ResearchProjectAdvice',
	'ResearchGrantAdvice',
	'DiversityInScienceAdvice',
	'TeachingAdvice',
	'SearchingForAcademicResources',
	'ProfessionalDevelopmentAdvice',
	'PersonalDevelopmentAdvice',
	'AcademiaToIndustryAdvice',
	'WritingPaperAdvice',
	'LnlmApplicationAdvice',
];

const formattedMentoringScopes: string[] = [
	'Career Mentoring',
	'Professional Development Mentoring',
	'Personal Development Mentoring',
	'Career Advice',
	'Study Advice',
	'Research Project Advice',
	'Research Grant Advice',
	'Diversity In Science Advice',
	'Teaching Advice',
	'Searching For Academic Resources',
	'Professional Development Advice',
	'Personal Development Advice',
	'Academia To Industry Advice',
	'Writing Paper Advice',
	'Lnlm Application Advice',
];

const positions: string[] = [
	'assistantProfessor',
	'associateProfessor',
	'adjunctProfessor',
	'departmentHead',
	'director',
	'graduateStudent',
	'researchDirector',
	'postdoctoralResident',
	'academiaInvestigator',
	'industryInvestigator',
	'lecturer',
	'programManager',
	'fullProfessor',
	'academiaScientist',
	'industryScientist',
	'retired',
	'scienceWriter',
	'teacher',
	'technician',
	'undegraduateStudent',
	'other',
];

const pronouns: string[] = [ 'she_her', 'he_him', 'they_them', ];

const researchFields: string[] = [
	'anthropology',
	'astronomy',
	'biochemistry',
	'bioinformatics',
	'biotechnology',
	'botany',
	'chemistry',
	'computerScience',
	'ecology',
	'economics',
	'genomics',
	'geology',
	'mathematics',
	'meteorology',
	'molecularBiology',
	'microbiology',
	'neuroscience',
	'oceanography',
	'oncology',
	'paleontology',
	'petrology',
	'pharmacology',
	'physiology',
	'physics',
	'pharmacognosyPlantMedicine',
	'psychology',
	'sociology',
	'stemCellResearch',
	'zoology',
	'other',
];

const titles: string[] = [ 'ms', 'mrs', 'mr', 'dr', ];

export {
	formattedMentoringScopes,
	lindauMeetings,
	positions,
	pronouns,
	researchFields,
	mentoringScopes,
	titles,
};